module.exports = __webpack_public_path__ + "static/services-image-3_d-9961861347a890eabaa000bc27315f42.jpg";